import { startCase } from 'es-toolkit';

export const getRelativeDay = (
  kind: 'today' | 'tomorrow' | 'yesterday' | 0 | 1 | -1,
  locale = window.navigator.language
) => {
  let day = 0;

  if (typeof kind === 'string') {
    day = { today: 0, tomorrow: 1, yesterday: -1 }[kind];
  } else {
    day = kind;
  }

  return startCase(
    new Intl.RelativeTimeFormat(locale, {
      style: 'long',
      numeric: 'auto'
    }).format(day, 'day')
  );
};
